module.exports = "../study/imgs/maps/Kanagawa/S8/Helth/HeatDisorder/Kanagawa_HeatDisorder_MRI_RCP85_Mid.png";